import { Container } from '@material-ui/core'
import { useIsMobile, useIsTablet } from 'lib/hooks'
import DisplayContact from './details-components/display-contact'
import EmergencyInformation from './details-components/emergency-information'
import AdditionalInformation from './details-components/additional-information'
import DeleteStudent from './details-components/delete-student'
import StudentStats from './details-components/stats'
import { useAuth } from 'lib/auth'

const StudentDetails = ({ student, stats }) => {
  const { id, contact, isMinor, medicalProfile, emergencyContact } = student
  const { data: { studentStatistics } = {}, loading } = stats
  const isTablet = useIsTablet()
  const isMobile = useIsMobile()
  const { user } = useAuth()
  const { hideSensitiveInformation } = user

  return (
    <Container style={{ marginTop: isTablet && '-20px' }}>
      <StudentStats
        totalRevenueInCents={studentStatistics?.totalRevenueInCents}
        totalBookingCount={studentStatistics?.totalBookingCount}
        privateBookingCount={studentStatistics?.privateBookingCount}
        groupSessionCount={studentStatistics?.groupSessionCount}
        loading={loading}
      />

      <DisplayContact isMinor={isMinor} contact={contact} />

      <AdditionalInformation studentId={id} />

      <EmergencyInformation
        medicalProfile={medicalProfile}
        emergencyContact={emergencyContact}
      />

      {!isMobile && !hideSensitiveInformation && (
        <DeleteStudent student={student} />
      )}
    </Container>
  )
}

export default StudentDetails
